import Button from '@talkdesk/cobalt-react-button'
import Box from '@talkdesk/cobalt-react-box'
import Flex from '@talkdesk/cobalt-react-flex'
import { Text, Heading } from '@talkdesk/cobalt-react-typography'
import {
  DISCLAIMER_TITLE,
  DISCLAIMER_SUBTITLE,
  DISCLAIMER,
  DISCLAIMER_ACK
} from '../../constants/ui.labels'

const DisclaimerBody = ({ onAcknowledge }) => (
  <>
    <Text size="small">{DISCLAIMER_TITLE.toUpperCase()}</Text>
    <Heading level={3}>{DISCLAIMER_SUBTITLE}</Heading>
    <Text>{DISCLAIMER}</Text>
    <Box paddingTop={4} />
    <Flex alignX="end">
      <Button type="primary" onClick={onAcknowledge}>
        {DISCLAIMER_ACK}
      </Button>
    </Flex>
  </>
)

export default DisclaimerBody
